import { beginTask, endTask } from 'redux-nprogress';
import { loadWeeks, selectCurrent, selectWeeks } from '../../../../store/reducers/season';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectFormulasState } from '../../../../store/reducers/formula';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'depthcharts';
export const selectDepthChartsState = state => state[STORE_KEY];
export const selectDepthCharts = state => selectDepthChartsState(state).currentDepthCharts;
export const selectDepthChartState = state => state[STORE_KEY];
export const selectDepthChart = state => selectDepthChartState(state).currentDepthChart;


// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  currentDepthCharts: {},
  currentDepthChart: {},
  year: null,
  week: null,
  formulaId: 1,
  hasLoaded: false,
  hasLoadedChart: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default reducer;


// ------------------------------------
// Load (real) Cheat Sheet from api
// ------------------------------------
export const LOAD_DEPTHCHART_REQUEST = `${STORE_KEY}/LOAD_DEPTHCHART_REQUEST`;
export const LOAD_DEPTHCHART_SUCCESS = `${STORE_KEY}/LOAD_DEPTHCHART_SUCCESS`;
export const LOAD_DEPTHCHART_ERROR = `${STORE_KEY}/LOAD_DEPTHCHART_ERROR`;

export const loadDepthChartRequest = payload => ({
  type: LOAD_DEPTHCHART_REQUEST,
  payload: { ...payload },
});
export const loadDepthChartSuccess = ( chart ) => ({
  type: LOAD_DEPTHCHART_SUCCESS,
  payload: { chart },
});
export const loadDepthChartError = error => ({
  type: LOAD_DEPTHCHART_ERROR,
  payload: { error },
});

actions[LOAD_DEPTHCHART_REQUEST] = (state, { payload }) => ({ ...state,
});

actions[LOAD_DEPTHCHART_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoadedChart: true,
  currentDepthChart: payload.chart,
});

actions[LOAD_DEPTHCHART_ERROR] = (state, { payload }) => ({ ...state,
  hasLoadedChart: false,
  error: payload.error,
});


export const loadDepthChart = () => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadDepthChartRequest());
    const depthchart = await api.teams.teamDepthChart('0');
    // console.log('depthchart', depthchart);
    return dispatch(loadDepthChartSuccess(depthchart));
  } catch (error) {
    console.error(error);
    return dispatch(loadDepthChartError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View
// ------------------------------------
export const DEPTHCHARTS_VIEW = `${STORE_KEY}/DEPTHCHARTS_VIEW`;

viewNames[DEPTHCHARTS_VIEW] = 'DepthCharts';
routes[DEPTHCHARTS_VIEW] = {
  path: '/nfl-depth-charts',
  thunk: async (dispatch, getState) => {
    const state = getState();

    let { week, formulaId } = selectQuery(state);
    let { year } = state.location.payload;

    const { season: currentYear, week: currentWeek } = selectCurrent(state, 'projections');

    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;

    await dispatch(loadWeeks(year));

    if (typeof week !== 'number') {
      if (year === currentYear) {
        week = currentWeek;
      } else {
        week = selectWeeks(getState(), year, 'projections')[0];
      }
    }

    // Needs to await otherwise data won't load on SSR
    // await dispatch(loadDepthCharts(2018, week, formulaId));
    await dispatch(loadDepthChart());
    await dispatch(loadToolDescriptions());
  },
};


// WEBPACK FOOTER //
// ./src/app/views/DepthCharts/module/depthcharts.js